import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { CompanyMetadataContext, CompanyMetadataInit } from "./context";
import { useGetOneCompany } from "src/api/client-api/company/useGetOneCompany";

type CompanyProviderProps = {
    children: JSX.Element;
};
export const CompanyMetadataProvider = (props: CompanyProviderProps) => {
    const { children } = props;
    const { selectedCompany } = useFoodpilotContext();

    const { company, isFetched, isRefetching } = useGetOneCompany({
        companyId: selectedCompany?.id,
    });

    if (isRefetching === false) {
        if (isFetched === false) {
            // It's loading, cheers.
            return;
        }
    }

    if (company === undefined) {
        // Error ? The company must exist;
        return;
    }

    const items: CompanyMetadataInit = {
        company,
    };

    return <CompanyMetadataContext.Provider value={items}>{children}</CompanyMetadataContext.Provider>;
};
